import { queryOptions, useSuspenseQuery } from "@tanstack/react-query";

import { ordersApi } from "@shared/api";

import { constants } from "./constants";

export const tradeOrdersAssetsQueryOptions = () =>
  queryOptions({
    queryFn: () => ordersApi.getApiV1TradeOrdersAssets(),
    queryKey: constants.assets(),
  });

export const useTradeOrdersAssets = () => {
  const { data, error, isPending } = useSuspenseQuery(
    tradeOrdersAssetsQueryOptions(),
  );

  return { error, tradeOrdersAssets: data.data.assets || [], isPending };
};
